import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'gfv-nb-parts',
    templateUrl: './gfv-nb-parts.component.html',
    styleUrls: ['./gfv-nb-parts.component.scss'],
    standalone: false
})
export class GfvNbPartsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  parameters;
  partPrice: number;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.partPrice = pledge?.products?.[0]?.parameters?.gfvPartPrice;

    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  get investmentAmount() {
    const data = this.products?.value;
    const partPrice = data?.[0]?.parameters?.gfvPartPrice;

    const amount = data?.reduce((acc, product) => {
      return acc + product?.parameters?.gfvNbParts * partPrice;
    }, 0);

    return {
      display: 'success',
      icon: 'success',
      text: `Correspondant à un investissement total de ${amount} €`,
    };
  }
  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
